// 企业Logo、Banner配置信息
// import arkUI from '@syman/ark-ui';
import enterpriseLogo from 'branchImages/logo_BRAND_PIC.png';
import enterpriseBanner from 'branchImages/banner_BRAND_PIC.png';
import customizedPageConfig from './src/config/customized.page.config';
import customizedModalConfig from './src/config/customized.modal.config';
import customizeWaterMarkConfig from './src/config/customized.watermark.config';
import getTitle from './src/config/title.config';
import WelcomePage from './entry/WelcomePage';
import Callback from './src/component/lining/modal/Callback.vue';
import SSOGetCode from './src/component/lining/modal/SSOGetCode.vue';
import Login from './entry/login';
import './src/assets/theme/custom.less';
import VueDND from 'awe-dnd';
import Print from 'vue-print-nb'
import closedImg from 'branchImages/foldIcon.png';
import openedImg from 'branchImages/UnfoldIcon.png';

import verticalTableDetailCustomize from './src/config/minxin/verticalTableDetailCustomize.js';
import horizontalTableDetailCustomize from './src/config/minxin/horizontalTableDetailCustomize.js';
import standardTableListsCustomize from './src/config/minxin/standardTableListsCustomize.js';

// import Bcl from '@syman/ark-ui-bcl';
// import '@syman/ark-ui-bcl/publish/ark.bcl.min.css'
// Vue.use(R3.default)
// Vue.use(Bcl.default);
Vue.use(Print);
// Vue.use(arkUI);
Vue.use(VueDND);
Vue.use(jflowPlugin.default, {
  changePattern: true,
  // gateway: 'ad-app',
  // roleSwitch:false
});
import projectRouterConfig from './src/config/router.config';
import dateUtil from "commonJs/date.js";

import {
  branch,
  Version,
  enableGateWay,
  enableJflow,
  jflowRequestDomain,
  jflowTabShow,
  custommizedJflow
} from '@/constants/global';
window.R3 = R3.default

R3.launchApplication({
  customizeMixins: { // 获取所有外部接入的mixins对象
    verticalTableDetailCustomize: verticalTableDetailCustomize(), // 上下结构单对象界面混入文件
    horizontalTableDetailCustomize: horizontalTableDetailCustomize(), // 上下结构单对象界面混入文件
    standardTableListsCustomize: standardTableListsCustomize(), // 标准列表界面混入文件
    // 处理详情界面的表格
    // tableDetailCollectionMixin: {
    //   methods: {
    //     R3_processColumns(columns) {
    //       return columns
    //      }
    //   }
    // }
  },
  layoutDirection: false,
  custommizedRequestURL: {
    '/p/cs/cspecobjload': '/r3/cabben/pt/cspecobjload',
    '/p/cs/cprospecload': '/r3/cabben/pt/cprospecload',
    '/p/cs/proImage': '/r3/cabben/pt/proImage',
    '/p/cs/cclrquery': '/r3/cabben/pt/cclrquery',


  }, // 配置内置自定义界面requestURL
  remarkEnable: process.env.BRANCH_ENV == 'lining' ? true : false,
  image: {
    enterpriseLogo,
    enterpriseBanner
  },
  globalComponent: {
    Login,
    WelcomePage,
    Callback,
    SSOGetCode,
  },
  // DashboardComponent: {
  //   // compontent: () => import('./entry/WelcomePage.vue'),
  //   compontent: () => import('./src/component/lining/page/unifiedTask.vue'),
  //   iconClass: 'iconfont iconmd-grid'
  // },
  Version: Version(),
  encryptedPassword: true, //登陆密码加密
  externalModules: customizedPageConfig,
  externalModals: customizedModalConfig,
  projectRoutes: projectRouterConfig,
  enableGateWay: enableGateWay(),
  enableJflow: enableJflow(),
  jflowRequestDomain: jflowRequestDomain(),
  jflowTabShow: jflowTabShow(),
  customizeWaterMark: customizeWaterMarkConfig,
  custommizedJflow: custommizedJflow(),
  isItemTableNewValidation: false, // 是否允许子表新增有必填项时，输入值才触发子表必填项校验，不输入值则只校验主表
  // 页面字段属性 
  setComponentsProps: (type, props) => {
    // 列表支持联动查询
    if (type === 'OBJ_FK') {
      if (props.PropsData && (props.PropsData.fkobj.searchmodel === 'mrp' || props.PropsData.fkobj.searchmodel === 'drp')) {
        props.PropsData.Query = true;
      }
    }
    // 店铺新开-详细地址 图标按钮点击触发事件
    // if (props.item && props.item.colid == 1700808155) {
    //   props.icon = 'ios-map';
    //   props.iconClick = function (e) {
    //     //获取参数
    //     //调用后台接口，验证以及返回省市区或者经纬度等信息
    //     //调用
    //     //
    //     const popupUrl = './src/component/lining/modal/SubIframe.vue';
    //     var userInput = window.open(popupUrl);
    //     // if (userInput != null) {
    //     //   // 用户输入了数据并点击了确定
    //     //   console.log('你输入的名字是：' + userInput);
    //     // } else {
    //     //   // 用户点击了取消
    //     //   console.log('用户取消了输入。');
    //     // }
    //   }
    // }
    // console.log('type :>> ', type);
    // console.log('props :>> ', props);
    if (props.item && ['现邮政编码', '邮政编码', '邮编'].includes(props.item.name)) {
      // console.log('type :>> ', type);
      // console.log('.props1 :>> ', props);
      props.regx = /^[0-9]*$/
    }
    if (['现邮政编码', '邮政编码', '邮编'].includes(props.name)) {
      props.regx = /^[0-9]*$/
      // console.log('.props2 :>> ', props);
    }
    return props;
  },
  externalTreeDatas: {
    CP_C_USERS: () => async () => {
      let data = [];
      let formdata = new FormData();
      formdata.append('type', 'IN');
      await network.post('/r3/cs/uc/selectOrgTree', formdata).then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          data = restructureMenuTreeData(res.data.data);
        }
      });
      const treeData = {
        data,
        name: 'CP_C_HRORG_ID'
      };
      return treeData;
    },
    CP_C_HRORG: () => async () => {
      let data = [];
      let formdata = new FormData();
      formdata.append('type', 'IN');
      await network.post('/r3/cs/uc/selectOrgTree', formdata).then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          data = restructureMenuTreeData(res.data.data);
        }
      });
      const treeData = {
        data,
        name: 'ID'
      };
      return treeData;
    },
    CP_C_INORG: () => async () => {
      let data = [];
      let firstParent = '';
      let formdata = new FormData();
      formdata.append('ORGTYPE', 'IN');
      await network.post('/p/cs/chrorgload', formdata).then((res) => {
        if (res.data.code == 0) {
          data = JSON.parse(JSON.stringify(res.data.data));
          firstParent = res.data.data.filter(item => item.CP_C_ORGUP_ID == null);
          firstParent[0].title = firstParent[0].ENAME;
          firstParent.forEach(item => {
            getTreeChildren(item, data);
          })
        }
      })
      const treeData = {
        data: firstParent,
        name: 'ID'
      };
      return treeData;
    }

  },
  externalPluginModules: {
    INSTANCEMANAGEMENTLIST: { // jflow插件待办列表界面
      component: jflowPlugin.components(),
      name: '工作流'
    },
  }
});

const {
  network,
  urlSearchParams
} = R3;

Vue.prototype.$network = network;
Vue.prototype.$urlSearchParams = urlSearchParams;
// console.log(network);
// console.log('jflowRequestDomain :>> ', jflowRequestDomain());

getTitle();
let img = {
  collapseImg: closedImg,
  expandImg: openedImg
};
R3.store.commit('global/updateImage', img);

network.axios.interceptors.request.use(function (config) {
  if (window.jflowEventParam && branch == 'lining') {
    config.headers['jflow-event-param'] = JSON.stringify(window.jflowEventParam)
  }
  if (config.url.includes('/p/cs/task/backlog/list') && branch == 'lining') {
    // console.log('config.data :>> ', config.data);
    config.url = '/p/cs/queryBackLogList';
    setConfigDataTime(config)
    if (!config.data.sortable) {
      config.data.sortable = "createTime"
      config.data.sortType = "desc"
    }
  }
  if (config.url.includes('/p/cs/task/history/list') && branch == 'lining') {
    config.url = '/p/cs/queryApprovedList';
    setConfigDataTime(config)
  }
  if (config.url.includes('/p/cs/task/initiator/list') && branch == 'lining') {
    config.url = '/p/cs/queryInitiatedList';
    setConfigDataTime(config)
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
//需求是没有设置处理时间时，查2020-07-01到现在
function setConfigDataTime(config) {
  if (config.data.startTime == "" && config.data.endTime == "") {
    //dateUtil.getFormatDate(currentDate, "yyyy-MM-dd") + " 00:00:00";
    config.data.startTime = "2020-07-01 00:00:00"
    let currentDate = dateUtil.getFormatDate(new Date(), "yyyy-MM-dd") + " 23:59:59"
    // console.log('currentDate :>> ', currentDate);
    config.data.endTime = currentDate
  }
}
network.axios.interceptors.response.use(async (response) => {
  //拦截工作流header API 把createTime默认值改为降序
  // console.log('response :>> ', response.config.headers['jflow-event-param']);
  if (response.config.headers['jflow-event-param']) {
    window.jflowEventParamWithStoreClose = JSON.parse(response.config.headers['jflow-event-param'])
  }
  if (response.config.url.includes('/p/cs/sys/grid/header') && branch == 'lining') {
    // console.log('response :>> ', response);
    let headers = response.data.data.headers
    if (response.data.data.gridName == "upcoming") {
      let newHeaders = setUpcomingHeader(headers)
      // let formdata = new FormData();
      // formdata.append('type', 'table');
      // formdata.append('id', '249130562');
      // let res = await axios.post("/p/cs/getUserConfig", formdata);
      // console.log('res11 :>> ', res);
      response.data.data.headers = newHeaders
    }
    if (response.data.data.gridName == "approved") {
      let newHeaders = setApprovedHeader(headers)
      response.data.data.headers = newHeaders
    }
    if (response.data.data.gridName == "initiated") {
      let newHeaders = setInitiatedHeader(headers)
      response.data.data.headers = newHeaders
    }
  }
  // 店铺档案 开店确认-详情 未实际开店 默认显示否
  if (branch == 'lining' && R3.router.app.$route.params.tableName === 'CP_C_STORE_NEW_1' && response.config.url.includes('/p/cs/getObject')) {
    let findColum = response.data.data.addcolums.find(item => item.parentdesc === '完成信息' && item.parentname === '(CP_C_STORE_NEW_1.ID+18)')
    let findChild = findColum.childs.find(item => item.colname === 'IS_NOT_OPEN')
    findChild.valuedata = '0'
  }
  //客户档案报表
  if (branch == 'lining' && R3.router.app.$route.params.tableName === 'CP_C_CUSTOMER_REPORT' && response.config.url.includes('/p/cs/QueryList')) {
    // console.log('response.data :>> ', response.config.data);
    if (response.config.data) {
      let paramList = response.config.data.split("searchdata=")
      if (paramList.length == 2) {
        let param = JSON.parse(decodeURIComponent(paramList[1]))
        if (param.table == 'CP_C_CUSTOMER_REPORT') {
          // console.log('客户档案报表 拦截修改tabth');
          let obj = response.data.datas
          if (obj && obj.tabth) {
            let hideColumn = response.data.hideColumn
            if (hideColumn) {
              window.customerReportHideColumn = hideColumn

              let hideColumnList = hideColumn.split(',')
              // console.log('hideColumnList :>> ', hideColumnList);
              // hideColumnList = ["ID", "CP_C_BUS_UNIT_ID", "ECODE", "PS_C_BRAND_ID", "CP_C_CUSTOMER_ATTR_VALUE_ID", "BUSINESS_LICENSES_NAME", "ENAME", "SHORT_NAME", "BUSINESS_LICENSES_ADDR", "BUSINESS_LICENSES_NO", "CUSTOMER_CLASSFIC", "CP_C_CUSTOMER_GROUP_ID", "CP_C_CUSTOMER_GROUP_ENAME", "CP_C_CUSTOMER_GROUP_LEVEL", "IS_COMPET", "PS_C_BRAND_COMPET_ID", "DELIVERY_MODE", "BUS_START_DATE", "BUS_END_DATE", "PHONE_NO", "LANGUAGE", "CP_C_EMP_ID", "IS_MAIN", "COOP", "CP_C_CUSTOMER_LEVEL_ID", "CP_C_CUSTOMER_LEVEL_SUPPLY_DISCOUNT_ID", "IS_SPECIAL_DISCOUNT", "SPECIAL_DISCOUNT", "CP_C_CUSTOMERUP_ID", "CP_C_CUSTOMERUP_ENAME", "CP_C_BIG_AREA_ID", "CP_C_PROV_AREA_ID", "CP_C_REGION_COUNTRY_ID", "CP_C_REGION_PROVICE_ID", "CP_C_REGION_CITY_ID", "CP_C_REGION_COUNTY_ID", "CP_C_REGION_TOWNSHIP_ID", "CP_C_REGION_RECEV_CITY_ID", "BUS_PERIOD", "SETUP_DATE", "REGISTERED_CAPITAL", "QTY_EMP", "AMT_FLOW", "AMT_ASSETS", "WAREHOUSE_AREA", "IS_SPORTS_EXPERIENCE", "SAP_ECODE", "CP_C_RECON_ACCOUNT_ID", "CP_C_SHIP_CONDITION_ID", "TAX_TYPE", "CP_C_FIX_PRICE_ID", "CP_C_TRADE_PARTNER_ID", "SUPPLIER_NAME", "INDUSTRY", "CP_C_CURRENCY_ID", "CP_C_PAY_TERMS_ID", "ACCOUNT_GROUP", "CP_C_ERP_ACC_GRP_ID", "IS_TAXPAYER", "TAX_CERTIFICATE_NO", "TAXPAYER_NO", "OPEN_BANK_NAME", "BANK_ACCOUNT", "INVOICE_NAME", "CUST_STATUS", "SYSTEM_ONLINE_DATE", "VALID_START_DATE", "VALID_END_DATE", "OPEN_DATE", "VALID_DATE", "REASON", "IDENTITY", "EXCEPT_CLOSE_DATE", "OWNERENAME", "CREATIONDATE", "MODIFIERENAME", "MODIFIEDDATE", "ISACTIVE"]
              let newTabth = obj.tabth.filter(item => !hideColumnList.includes(item.colname))
              // console.log('newTabth :>> ', newTabth);
              // response.data.datas.tabth = newTabth
              window.customerReportAgtableTabth = newTabth
            } else {
              window.customerReportAgtableTabth = obj.tabth
              window.customerReportHideColumn = ''
              window.extraCustomerReportHideColumn = ''
              let formdata = new FormData();
              formdata.append('tableid', 249130562);
              formdata.append('hidecolumns', '');
              await network.axios.post("/p/cs/setHideColumn", formdata)
            }
          }
        }
      }
    }
  }
  //店铺档案报表
  if (branch == 'lining' && R3.router.app.$route.params.tableName === 'CP_C_STORE_REPORT' && response.config.url.includes('/p/cs/QueryList')) {
    // console.log('response.data :>> ', response.config.data);
    if (response.config.data) {
      let paramList = response.config.data.split("searchdata=")
      if (paramList.length == 2) {
        let param = JSON.parse(decodeURIComponent(paramList[1]))
        if (param.table == 'CP_C_STORE_REPORT') {
          // console.log('店铺档案报表 拦截修改tabth');
          let obj = response.data.datas
          if (obj && obj.tabth) {
            let hideColumn = response.data.hideColumn
            if (hideColumn) {
              window.storeReportHideColumn = hideColumn

              let hideColumnList = hideColumn.split(',')
              // console.log('hideColumnList :>> ', hideColumnList);
              let newTabth = obj.tabth.filter(item => !hideColumnList.includes(item.colname))
              // console.log('newTabth :>> ', newTabth);
              window.storeReportAgtableTabth = newTabth
            } else {
              window.storeReportAgtableTabth = obj.tabth
              window.storeReportHideColumn = ''
              window.extraStoreReportHideColumn = ''
              let formdata = new FormData();
              formdata.append('tableid', 249130559);
              formdata.append('hidecolumns', '');
              network.axios.post("/p/cs/setHideColumn", formdata)
            }
          }
        }
      }
    }
  }
  return response
}, (response) => { /*  对响应错误做点什么 （statusCode !== 200）*/
  return Promise.reject(response)
})
//工作流-待我审批
function setUpcomingHeader(headers) {
  if (!headers) return []
  let newHeaders = []
  newHeaders.push(headers.find(item => item.type == "selection")) //selection
  let remarkMsg = headers.find(item => item.key == "remarkMsg") //客户/店铺信息
  remarkMsg.align = "center"
  remarkMsg.width = 240
  newHeaders.push(remarkMsg)
  newHeaders.push(headers.find(item => item.key == "cP_C_BUS_UNIT_ID")) //业务单元
  newHeaders.push(headers.find(item => item.key == "cP_C_BIG_AREA_ID")) //大区 
  newHeaders.push(headers.find(item => item.key == "cP_C_PROV_AREA_ID")) //省区
  newHeaders.push(headers.find(item => item.key == "businessNumber")) //查询索引
  newHeaders.push(headers.find(item => item.key == "businessName")) //单据类型
  newHeaders.push(headers.find(item => item.key == "approverValue")) //待审批人
  newHeaders.push(headers.find(item => item.key == "nodeName")) //节点名称
  newHeaders.push(headers.find(item => item.key == "moduleName")) //模板名称
  newHeaders.push(headers.find(item => item.key == "initiatorName")) //发起人
  let createTime = headers.find(item => item.key == "createTime") //处理时间
  createTime.sortType = "desc"
  newHeaders.push(createTime)
  let durationTime = headers.find(item => item.key == "durationTime") //消耗时长
  durationTime.title = "处理时长"
  newHeaders.push(durationTime)
  newHeaders.push(headers.find(item => item.key == "instanceId")) //工作流编号
  newHeaders.push(headers.find(item => item.key == "processStatusName")) //流程状态
  newHeaders.push(headers.find(item => item.key == "oWNERENAME")) //创建人
  newHeaders.push(headers.find(item => item.key == "cREATIONDATE")) //创建时间
  return newHeaders
}
//工作流-我已审批的
function setApprovedHeader(headers) {
  if (!headers) return []
  let newHeaders = []
  // newHeaders.push(headers.find(item => item.type == "selection")) //selection
  let remarkMsg = headers.find(item => item.key == "remarkMsg") //客户/店铺信息
  remarkMsg.width = 240
  remarkMsg.align = "center"
  newHeaders.push(remarkMsg)
  newHeaders.push(headers.find(item => item.key == "cP_C_BUS_UNIT_ID")) //业务单元
  newHeaders.push(headers.find(item => item.key == "cP_C_BIG_AREA_ID")) //大区 
  newHeaders.push(headers.find(item => item.key == "cP_C_PROV_AREA_ID")) //省区
  newHeaders.push(headers.find(item => item.key == "businessNumber")) //查询索引
  newHeaders.push(headers.find(item => item.key == "businessName")) //单据类型
  // newHeaders.push(headers.find(item => item.key == "approverValue")) //待审批人
  newHeaders.push(headers.find(item => item.key == "nodeName")) //节点名称
  newHeaders.push(headers.find(item => item.key == "moduleName")) //模板名称
  newHeaders.push(headers.find(item => item.key == "initiatorName")) //发起人
  newHeaders.push(headers.find(item => item.key == "createTime")) //处理时间
  let durationTime = headers.find(item => item.key == "durationTime") //消耗时长
  durationTime.title = "处理时长"
  newHeaders.push(durationTime)
  newHeaders.push(headers.find(item => item.key == "instanceId")) //工作流编号
  newHeaders.push(headers.find(item => item.key == "processStatusName")) //流程状态
  newHeaders.push(headers.find(item => item.key == "oWNERENAME")) //创建人
  newHeaders.push(headers.find(item => item.key == "cREATIONDATE")) //创建时间
  return newHeaders
}
//工作流-我发起的
function setInitiatedHeader(headers) {
  if (!headers) return []
  let newHeaders = []
  // newHeaders.push(headers.find(item => item.type == "selection")) //selection
  let remarkMsg = headers.find(item => item.key == "remarkMsg") //客户/店铺信息
  remarkMsg.width = 240
  remarkMsg.align = "center"
  newHeaders.push(remarkMsg)
  newHeaders.push(headers.find(item => item.key == "cP_C_BUS_UNIT_ID")) //业务单元
  newHeaders.push(headers.find(item => item.key == "cP_C_BIG_AREA_ID")) //大区 
  newHeaders.push(headers.find(item => item.key == "cP_C_PROV_AREA_ID")) //省区
  newHeaders.push(headers.find(item => item.key == "businessNumber")) //查询索引
  newHeaders.push(headers.find(item => item.key == "businessName")) //单据类型
  // newHeaders.push(headers.find(item => item.key == "approverValue")) //待审批人
  // newHeaders.push(headers.find(item => item.key == "nodeName")) //节点名称
  newHeaders.push(headers.find(item => item.key == "moduleName")) //模板名称
  // newHeaders.push(headers.find(item => item.key == "initiatorName")) //发起人
  newHeaders.push(headers.find(item => item.key == "createTime")) //处理时间
  let durationTime = headers.find(item => item.key == "durationTime") //消耗时长
  durationTime.title = "处理时长"
  newHeaders.push(durationTime)
  newHeaders.push(headers.find(item => item.key == "instanceId")) //工作流编号
  newHeaders.push(headers.find(item => item.key == "processStatusName")) //流程状态
  newHeaders.push(headers.find(item => item.key == "oWNERENAME")) //创建人
  newHeaders.push(headers.find(item => item.key == "cREATIONDATE")) //创建时间
  return newHeaders
}

function restructureMenuTreeData(data) {
  return data.map((item) => {
    item.title = item.ename;
    item.ID = item.id;
    if (item.children && item.children.length > 0) {
      restructureMenuTreeData(item.children);
    }
    return item;
  });
}

function getTreeChildren(pnode, arr) {
  pnode.children = arr.filter(item => item.CP_C_ORGUP_ID === pnode.ID);
  pnode.children.forEach(item => {
    item.lastChild = false;
    item.title = item.ENAME;
    // item.expand = true;
    pnode.children[pnode.children.length - 1].lastChild = true;
    getTreeChildren(item, arr);
  })
}
// console.log(process.env.BRANCH_ENV);


window.addEventListener('exeActionSuccessForR3', (data) => {
  console.log(1111);
  console.log(data);
  if (data.detail.tableName == "V_CL_C_CUST_OPEN_FINANCE" || data.detail.tableName ==
    "CL_C_CUST_CHANGE_CL_FINANCE" || data.detail.tableName ==
    "V_CL_C_CUST_RELAT_CHG_GL" || data.detail.tableName == "CL_C_CUST_OPEN_EXPAND_FINANCE" || data.detail
      .tableName == "CL_C_CUST_COLSE_APPLY_GL" || data.detail.tableName ==
    "CL_C_STORE_OPEN_NEW_F" || data.detail.tableName == "V_CL_C_STORE_IMPROVE_GL" || data.detail
      .tableName == "CP_C_STORE_PROPERTY_FI_CHG" || data.detail.tableName ==
    "V_CL_C_STORE_CLOSE_GL" || data.detail.tableName == "CL_C_CUST_RELAT_FX_CHG_GL" || data.detail
      .tableName == "V_CL_C_STORE_OPEN_SPECIAL_MARKET_GL" || data.detail.tableName ==
    "CL_C_CUST_OPEN_CW" || data.detail.tableName == "CL_C_CUST_CHANGECONFIRM" || data.detail.tableName ==
    "V_CL_C_CUST_RELAT_CHG_CWSH" || data.detail.tableName ==
    "CL_C_CUST_OPEN_EXPAND_CW" || data.detail.tableName == "CL_C_CUST_COLSE_APPLY_SH" || data.detail
      .tableName == "CL_C_STORE_OPEN_NEW_SH" || data.detail.tableName ==
    "V_CL_C_STORE_IMPROVE_SH" || data.detail.tableName == "CP_C_STORE_PROPERTY_SH_CHG" || data.detail
      .tableName == "V_CL_C_STORE_CLOSE_SH" || data.detail.tableName ==
    "CL_C_CUST_RELAT_FX_CHG_SH" || data.detail.tableName == "V_CL_C_STORE_OPEN_SPECIAL_MARKET_SH" || data.detail
      .tableName == "CL_C_STORE_OPEN_NEW_FI") {
    R3.store.commit('global/tabCloseAppoint', {
      tableName: data.detail.tableName, //(主表表名),
      routeFullPath: data.detail.routePath //（路由path）
    });
  }
  console.log(data);
  // 如果为待认证客户查询 认证接口
  if (data.detail.tableName == 'CP_C_CUSTOMER_AUTH_DATE') {
    R3.store.commit("global/tabOpen", {
      type: 'tableDetailVertical',
      tableName: 'CL_C_CUST_AUTHENTICATION',
      tableId: 249130108,
      id: data.detail.res.data.data,
    });
  }
  if (data.detail.tableName == 'CP_C_STORE_AUTH_DATE' &&
    !(data.detail.res.data.data && data.detail.res.data.data == "BulkStoreAttestation")) {
    R3.store.commit("global/tabOpen", {
      type: 'tableDetailVertical',
      tableName: 'CL_C_STORE_AUTHENTICATION',
      tableId: 249130163,
      id: data.detail.res.data.data,
    });
  }
  // 如果为门店档案撤场重开
  console.log(data.detail.res.data.data);
  if (data.detail.tableName == 'CP_C_RSTORE') {
    if (data.detail.res.data.isDynRoute == '1') { // 判断是否动态路由
      R3.store.commit("global/tabOpen", {
        type: 'H',
        tableName: data.detail.res.data.skipTableName,
        tableId: data.detail.res.data.skipTableId,
        id: data.detail.res.data.data,
      });
    } else {
      R3.store.commit("global/tabOpen", {
        type: 'H',
        tableName: 'CP_C_STORE_ITEM_APPLICATION',
        tableId: 249130407,
        id: data.detail.res.data.data,
      });
    }

  }
  // 客户档案、供应商档案
  if (data.detail.tableName == 'CP_C_CUSTOMER' || data.detail.tableName == 'CP_C_SUPPLIER') {
    if (data.detail.res.data.isDynRoute == '1') { // 判断是否动态路由
      R3.store.commit("global/tabOpen", {
        type: 'H',
        tableName: data.detail.res.data.skipTableName,
        tableId: data.detail.res.data.skipTableId,
        id: data.detail.res.data.data,
      });
    }
  }
  // 如果网店档案撤场重开
  if (data.detail.tableName == 'CP_C_SHOP') {
    if (data.detail.res.data.isDynRoute == '1') { // 判断是否动态路由
      R3.store.commit("global/tabOpen", {
        type: 'H',
        tableName: data.detail.res.data.skipTableName,
        tableId: data.detail.res.data.skipTableId,
        id: data.detail.res.data.data,
      });
    } else {
      R3.store.commit("global/tabOpen", {
        type: 'H',
        tableName: 'CP_C_SHOP_ITEM_APPLICATION',
        tableId: 249130402,
        id: data.detail.res.data.data,
      });
    }

  }

})